import { CustomerData } from 'shared/services/api/models/customerData'
import { Model } from 'shared/services/api/models/Model'
import MountPoints from 'shared/utils/mountPoints'
import { OrderMasterData } from './orderMasterData'
import { OrderResponseV1, SuborderV1 } from './ordersResponseTypes'
import { Suborder } from './suborder'

export class OrderResponse extends Model {
  public readonly customerMasterData: CustomerData
  public readonly orderMasterData: OrderMasterData
  public readonly subOrders: Suborder[]

  constructor(src: OrderResponseV1) {
    super(src)
    if (src.customerMasterData) {
      this.customerMasterData = new CustomerData(src.customerMasterData)
    }
    if (src.orderMasterData) {
      this.orderMasterData = new OrderMasterData(src.orderMasterData)
    }
    this.subOrders = Array.isArray(src.subOrders)
      ? src.subOrders.map((suborder: SuborderV1) => new Suborder(suborder))
      : []
    this.status = this.getStatus()
  }

  public getSubOrderById(subOrderId: string): Suborder {
    const suborder: Suborder = this.subOrders.find(
      (so: Suborder) => so.subOrderId === subOrderId
    )
    if (suborder) {
      return suborder
    }
    throw new Error(`Suborder with ${subOrderId} is not found`)
  }

  // Work-around for SA order only.
  // See if still valid in the context of marketplace
  getStatus(): string {
    if (this.subOrders?.length === 0) {
      return null
    }
    const [suborder] = this.subOrders
    return suborder.status
  }

  public buildOrderDocumentsURLs(mountPoints: MountPoints) {
    this.subOrders.forEach(s =>
      s.documentsToDownload.forEach(d => d.getDocumentURL(mountPoints))
    )
  }
}
